import { render, staticRenderFns } from "./CurrentTariff.vue?vue&type=template&id=750aafee&scoped=true&"
import script from "./CurrentTariff.vue?vue&type=script&lang=js&"
export * from "./CurrentTariff.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTariff.vue?vue&type=style&index=0&id=750aafee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750aafee",
  null
  
)

export default component.exports